export default "__VITE_ASSET__QIECxS9X__"